import { defineMessages } from 'react-intl';

const messages = defineMessages({
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  contactInfo: {
    id: '5axkLt',
    defaultMessage: 'For a solution this size please get in touch with us.',
  },
  contactInfo_cloud: {
    id: 'Unba3M',
    defaultMessage: 'Based on your annual cloud spend, ',
  },
  contactInfo_cloud_1: {
    id: '+Ohs2K',
    defaultMessage: 'Turbonomic Essentials ',
  },
  contactInfo_cloud_2: {
    id: 'FSPc9g',
    defaultMessage: 'will best meet your needs. Contact us to get started.',
  },
  feedbackCharacters: {
    id: '0Bc7rz',
    defaultMessage: 'Characters.',
  },
  estimatedRoi: {
    id: 'hxKOo2',
    defaultMessage: 'Estimated ROI',
  },
  feedbackInvalidMaximum: {
    id: '+uPBEM',
    defaultMessage: 'Maximum number of characters to process',
  },
  CloseText: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  feedback500: {
    id: '4XFlJg',
    defaultMessage: 'Thank you, but something went wrong!',
  },
  feedBackText: {
    id: 'XvuIXj',
    defaultMessage: 'Is this helpful:',
  },
  calculationMessage: {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  productToAcquireHeadTooltip: {
    id: 'K5KS8K',
    defaultMessage: 'Product to acquire',
  },
  modalContinue: {
    id: 'acrOoz',
    defaultMessage: 'Continue',
  },
  feedBackNotHelpfull: {
    id: '04tuTF',
    defaultMessage: 'Not helpful',
  },
  inlineTextTitleSaaS: {
    id: 'j3GVIG',
    defaultMessage: 'Software as a service information',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  TotalCurrentCostOnPremHostTilte: {
    id: 'cZHHW2',
    defaultMessage: 'Current cost per on-premises host (USD)',
  },
  productToAcquire: {
    id: '9ky+23',
    defaultMessage: 'Product to acquire:',
  },
  contactUs: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  totalOnPremiseHeadTooltip: {
    id: 'bETJPe',
    defaultMessage: 'On-premises VMs',
  },
  inlineTextTitleLicense: {
    id: 'xT02Hd',
    defaultMessage: 'Software license subscription information',
  },
  totalOnPremVvmsTitle: {
    id: 'LtILKn',
    defaultMessage: 'Number of on-prem VMs',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  estimatedCosts: {
    id: 'YBINwe',
    defaultMessage: 'Estimated price',
  },
  totalCurrentNumberOnPremHostsTitle: {
    id: 'g+V56I',
    defaultMessage: 'Current number of on-premises hosts',
  },
  getQuoteButton: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  annualGrowthRateOnPremVMTitle: {
    id: 'fOmivl',
    defaultMessage: 'Annual growth rate on-premises VMs:',
  },
  getQuoteButton2: {
    id: 'DXQb1r',
    defaultMessage: 'Get your best price',
  },
  selection: {
    id: 'qVGRIE',
    defaultMessage: 'Quantity',
  },
  interestedInContainersLabel: {
    id: 'mR6Ln1',
    defaultMessage: 'Are you interested in container pricing?',
  },
  feedBackHelpfull: {
    id: '5vwKkg',
    defaultMessage: 'Helpful',
  },
  getROIButton: {
    id: 'vPejnf',
    defaultMessage: 'View IBM Turbonomic benefits',
  },
  widgetInfo: {
    id: '0rmPuU',
    defaultMessage:
      "Once you've created your estimate, request a customized pricing quote including volume discounts to match your business goals.",
  },
  widgetInfo1: {
    id: 'IEXlFh',
    defaultMessage: 'Contact us for details.',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  annualGrowthRateCloudInstanceTitle: {
    id: 'DHpDOj',
    defaultMessage: 'Annual growth rate cloud instances:',
  },
  feedbackEmailHolder: {
    id: 'Q75vbh',
    defaultMessage: 'Example: yourEmail@ibm.com',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  labelTotalOnPremVms: {
    id: 'AVCR/p',
    defaultMessage: 'Total number of on-premises VMs to be managed:',
  },
  availableIn: {
    id: 'igQyQv',
    defaultMessage: 'The Turbonomic estimator is available in',
  },
  totalCloudInstancesTitle: {
    id: 'ExXiFI',
    defaultMessage: 'Number of cloud instances',
  },
  feedback203: {
    id: '7FTPXh',
    defaultMessage: 'Sorry, I could sent the feedback!',
  },
  feedbackComment: {
    id: '4FQrdH',
    defaultMessage: 'Comment:',
  },
  feedbackEmail: {
    id: 'zuu8pi',
    defaultMessage: 'Email (optional):',
  },
  feedbackHeaderText: {
    id: 'qxui/f',
    defaultMessage: 'Feedback form',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  totalOnPremiseDescTooltip: {
    id: 'HHz0jV',
    defaultMessage:
      'Please move the slider to indicate the number of on-premises virtual machines you would like to include in your IBM Turbonomic software license.',
  },
  feedback200: {
    id: 'FxvkF9',
    defaultMessage: 'Thank you! Your feedback was sent',
  },
  oneYearEstimatedCosts: {
    id: '7U4yNh',
    defaultMessage: '1 Year estimated price',
  },
  totalCloudInstancesHeadTooltip: {
    id: 'oyYeqQ',
    defaultMessage: 'Cloud-hosted instances',
  },
  totalCurrentMonthtlyCloudBillTitle: {
    id: 'dvG40V',
    defaultMessage: 'Current monthly cloud Bill (USD)',
  },
  feedbackInvalidMinimum: {
    id: 'fkJa3C',
    defaultMessage: 'Minimum number of characters to process',
  },
  requiremnet: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  labelTotalCloudInstances: {
    id: 'YTQ/FO',
    defaultMessage: 'Total number of cloud instances to be managed:',
  },
  widgetText_1: {
    id: '4+KBJd',
    defaultMessage:
      'Find the right plan for your environment and estimate your IBM Turbonomic price',
  },
  widgetText_4: {
    id: 'gwJiMs',
    defaultMessage: 'Pricing plans',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  widgetText_3: {
    id: 'L3kuII',
    defaultMessage: 'price',
  },
  interestedInContainersDescTooltip: {
    id: 'zZrJlJ',
    defaultMessage:
      'If you would like to obtain a detailed quote for containers, please toggle this switch.',
  },
  feedbackSubmit: {
    id: 'wSZR47',
    defaultMessage: 'Submit',
  },
  feedbackCancel: {
    id: '47FYwb',
    defaultMessage: 'Cancel',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  feedbackInvalidEmail: {
    id: 'HBERi+',
    defaultMessage: 'Invalid email.',
  },
  totalCloudInstancesDescTooltip: {
    id: 'FZhOQW',
    defaultMessage:
      'Please move the slider to indicate the number of cloud-hosted instances (AWS, Azure, GCP) you would like to include in your IBM Turbonomic software license.',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  invalidVmText_1: {
    id: 'OL+Brn',
    defaultMessage: 'Maximum to process',
  },
  feddbackPhraseText: {
    id: 'yI2J2z',
    defaultMessage:
      'Please provide your thoughts about what we can do to better?',
  },
  invalidVmText_2: {
    id: 'rbQRab',
    defaultMessage: ' Please contact us',
  },
  invalidVmText_3: {
    id: 'zSj5Ir',
    defaultMessage: 'Minimum to process ',
  },
  footnoteOne: {
    id: 'fkmyz5',
    defaultMessage:
      'Estimated cost is not a formal offer from IBM or an IBM Business Partner. Certain factors such as Turbonomic configuration, add-ons, and discounts may affect estimated costs. IBM Business Partners set and provide their own IBM Turbonomic pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate. Your quoted price will likely vary. Prices in local currency will likely vary. Minimum term is 12 months. Estimated cost is only applicable to Turbonomic SaaS and Turbonomic ARM On Prem v. 8.',
  },
  productToAcquireDescTooltip: {
    id: 'PM69bu',
    defaultMessage:
      'Please select the run mode of the product as SaaS or software (on-premises).',
  },
  asteriskPrice: {
    id: 'C7lG0E',
    defaultMessage: 'Prices shown do not iclude tax.',
  },
  inlineTextLicense: {
    id: 'mQxRPU',
    defaultMessage: 'Pricing does not include the cost of infrastructure.',
  },
  feedbackCommentHolder: {
    id: '6jv80B',
    defaultMessage: 'Your comments here...',
  },
  contactInfo2: {
    id: 'fJD4UX',
    defaultMessage:
      'You may qualify for volume discounting! Request a quote for the best possible price.',
  },
  modalResponseText: {
    id: 'MgdnPi',
    defaultMessage: 'Response',
  },
  threeYearEstimatedCosts: {
    id: '2A0O3x',
    defaultMessage: '3 Year estimated price',
  },
  interestedInContainersHeadTooltip: {
    id: 'YJkx6M',
    defaultMessage: 'Quote pricing containers',
  },
  interestedInContainersTilte: {
    id: 'aDa1hc',
    defaultMessage: 'Interested in pricing containers',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  inlineTextSaaS: {
    id: 'HlFFqy',
    defaultMessage:
      'All the benefits of the IBM Turbonomic platform without the need to invest in hardware and software.',
  },
  userStuckModalText: {
    id: 'dYU1Kl',
    defaultMessage:
      'Thank you for using the Turbonomic pricing & ROI estimator! It looks like you may be stuck. How can we help you?',
  },
  userStuckModalPrimaryButton: {
    id: 'h/St7H',
    defaultMessage: 'I need specific pricing information',
  },
  userStuckModaSecondaryButton: {
    id: 'IuSmO8',
    defaultMessage: "I'd like to give feedback",
  },
  cloud_tile: {
    id: 'jWjr7Z',
    defaultMessage: 'Cloud only',
  },
  onprem_hybrid_tile: {
    id: 'Jx+PRN',
    defaultMessage: 'On Prem/ Hybrid',
  },
  question_title: {
    id: 'VY83b6',
    defaultMessage: 'Are you looking to optimize Cloud Only or On Prem/Hybrid?',
  },
  question_cloud: {
    id: 'MhfvJG',
    defaultMessage: 'What is your annual cloud spend?',
  },
});

export default messages;
